export default "__VITE_ASSET__D0Y8XzuQ__"